import script from "./NoticeList.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeList.vue?vue&type=script&setup=true&lang=js"

import "./NoticeList.vue?vue&type=style&index=0&id=3860cf0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3860cf0e"]])

export default __exports__